module.exports = __webpack_public_path__ + "img/2@2x.b493d003.png";